import Vue from 'vue';
import VueRouter from 'vue-router';
import AdministracionMain from '@/views/administracion/Main.vue';
import ContratistasMain from '@/views/contratistas/Main.vue';
import Login from '@/views/public/Login.vue';
import Logout from '@/views/public/Logout.vue';
import Contratistas from './contratistas';
import Administracion from './administracion';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'administracion',
    meta: {
      title: '',
      auth: true,
    },
    component: AdministracionMain,
    children: [
      ...Administracion,
    ],
  },
  {
    path: '/contratistas',
    name: 'contratistas',
    meta: {
      title: 'Contratistas',
      auth: [],
    },
    component: ContratistasMain,
    children: [
      ...Contratistas,
    ],
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Iniciar sesion',
      auth: false,
    },
    component: Login,
    children: [],
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      title: 'Cerrar sesion',
      auth: false,
    },
    component: Logout,
    children: [],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const { isAuthenticated, isLoading } = Vue.prototype.$auth;
  const requiereAuth = to.meta.auth;
  document.title = `SIDEOP - ${to.meta.title}`;
  if (requiereAuth && !isAuthenticated && !isLoading) {
    next({ name: 'login' });
  } else {
    next();
  }
  Vue.prototype.$auth.validarRuta(to.path, to.meta.auth);
});

export default router;
